import { graphql } from "@/graphql/generated/gql";

export const getPhaseListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query GetPhaseListForWorkspace($input: GetPhaseListForWorkspaceInput!) {
    phaseListForWorkspace(getPhaseListForWorkspaceInput: $input) {
      ...PhaseFields
      instanceList {
        ...PhaseInstanceFields
      }
    }
  }
`);

export const getPhaseQueryDocument = graphql(/* GraphQL */ `
  query GetPhase($input: GetPhaseInput!) {
    phase(getPhaseInput: $input) {
      ...PhaseFields
      instanceList {
        ...PhaseInstanceFields
      }
    }
  }
`);

export const createPhaseMutationDocument = graphql(/* GraphQL */ `
  mutation createPhase($input: CreatePhaseInput!) {
    createPhase(createPhaseInput: $input) {
      ...PhaseFields
    }
  }
`);

export const updatePhaseMutationDocument = graphql(/* GraphQL */ `
  mutation UpdatePhase($input: UpdatePhaseInput!) {
    updatePhase(updatePhaseInput: $input) {
      ...PhaseFields
    }
  }
`);

export const deletePhaseMutationDocument = graphql(/* GraphQL */ `
  mutation DeletePhase($input: DeletePhaseInput!) {
    deletePhase(deletePhaseInput: $input) {
      ...PhaseFields
    }
  }
`);

export const reorderPhaseMutationDocument = graphql(/* GraphQL */ `
  mutation ReorderPhase($input: ReorderPhaseInput!) {
    reorderPhase(reorderPhaseInput: $input) {
      ...PhaseFields
    }
  }
`);
